import { tryCatchHelper } from '../../../helpers';
import {
  deleteTiposNivelClasesService,
  getAllTiposNivelClasesService,
  getOneTiposNivelClasesService,
  saveTiposNivelClasesService,
} from '../../../services';
import {
  ACTIVO_TIPOS_NIVEL_CLASES,
  GETALL_TIPOS_NIVEL_CLASES,
  LOADING_GETALL_TIPOS_NIVEL_CLASES,
} from './TiposNivelClasesReducer';

export const getAllTiposNivelClasesAction = async (dispatch, entityId) => {
  try {
    dispatch({
      type: LOADING_GETALL_TIPOS_NIVEL_CLASES,
      payload: true,
    });
    const res = await getAllTiposNivelClasesService({ entityId });
    if (res.status === 200) {
      dispatch({
        type: GETALL_TIPOS_NIVEL_CLASES,
        payload: res.data,
      });
      dispatch({
        type: LOADING_GETALL_TIPOS_NIVEL_CLASES,
        payload: false,
      });
      return res.data;
    }
    dispatch({
      type: LOADING_GETALL_TIPOS_NIVEL_CLASES,
      payload: false,
    });
    return null;
  } catch (e) {
    dispatch({
      type: LOADING_GETALL_TIPOS_NIVEL_CLASES,
      payload: false,
    });
    let message =
      e.response?.data?.message ||
      e.message ||
      'Error al intentar, realizar el proceso';
    if (Array.isArray(e.message)) message = e.message.join(', ');
    if (Array.isArray(e.response?.data?.message)) {
      message = e.response?.data?.message.join(', ');
    }
    console.warn(message);
  }
};

export const saveTiposNivelClasesAction = async (
  { dispatch, addNotification },
  entityId,
  id,
  data
) => {
  try {
    const res = await saveTiposNivelClasesService(id, data);
    addNotification(
      res.message ?? id
        ? 'El tipo de documento actualizado.'
        : 'El tipo de documento registrado.'
    );
    await getAllTiposNivelClasesAction(dispatch, entityId);
    return true;
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};

export const setActivoTiposNivelClasesAction = async (dispatch, data) => {
  dispatch({
    type: ACTIVO_TIPOS_NIVEL_CLASES,
    payload: data,
  });
};

export const getOneTiposNivelClasesAction = async (dispatch, id) => {
  try {
    const res = await getOneTiposNivelClasesService(id);
    if (res.status === 200) {
      await setActivoTiposNivelClasesAction(dispatch, res.data);
      return true;
    }
    return false;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteTiposNivelClasesAction = async (
  { dispatch, addNotification },
  id,
  entityId
) => {
  try {
    const res = await deleteTiposNivelClasesService(id, entityId);
    if (res.status === 200) {
      addNotification(res.data?.message ?? 'Tipo de documento eliminado.');
      await setActivoTiposNivelClasesAction(dispatch, null);
      await getAllTiposNivelClasesAction(dispatch, entityId);
      return true;
    }
    return false;
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};
